var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    d: "m25.26 9.452-.013.002a7.45 7.45 0 0 0-.542-4.807C23.58 2.217 21.28.403 18.627.065a7.825 7.825 0 0 0-8.25 4.76 3.9 3.9 0 0 0-1.414-.262A4.074 4.074 0 0 0 4.89 8.636a4 4 0 0 0 .117.932c-.977-.23-2.048-.204-3.346.845-.964.78-1.674 1.918-1.66 3.159A4.074 4.074 0 0 0 4.073 17.6h20.99c1.905 0 3.702-1.212 4.147-3.064a4.08 4.08 0 0 0-3.95-5.084"
  })));
};
export default SvgCloud;